import { jsx as e } from "react/jsx-runtime";

import { CELL_SPACING as t } from "../../constants/index.js";

import r from "../../hooks/useTableContext/index.js";

import { Cell as o } from "react-aria-components";

import a from "../../../../utils/classNames/index.js";

const s = ({children: s, className: n, id: i, textValue: l, ...m}) => {
    const {cellSpacing: c, rowSeparator: d} = r();
    return e(o, {
        ...m,
        textValue: l || "string" == typeof s && s || void 0,
        className: a("text-neutral flex-1", d && "border-b border-neutral-300", t[c], n),
        children: s
    });
};

export { s as default };
//# sourceMappingURL=index.js.map
